"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateRegex = exports.BasicObj = void 0;
exports.setValues = setValues;
var _moment = _interopRequireDefault(require("moment/moment"));
var _uuid = require("uuid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /*
 * MIT License
 *
 * Copyright (c) 2022 Massimo Candela <https://massimocandela.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var dateRegex = exports.dateRegex = new RegExp("^[0-9][0-9][0-9][0-9]-[0-9].*T[0-9].*Z$");
var globalError = "_object";
function setValues(values, model, SubObj, parent, context) {
  if (!values) {
    throw new Error("The parameter \"values\" cannot be null");
  }
  Object.keys(values).forEach(function (key) {
    var value = values[key];
    if (model.options.parseMoment && value != null && dateRegex.test(value)) {
      var mmnt = (0, _moment["default"])(value);
      context[key] = mmnt.isValid() ? mmnt : value;
    } else if (model.options.deep && value != null && _typeof(value) === "object" && !Array.isArray(value)) {
      if (context[key] && _typeof(context[key]) === "object") {
        setValues(value, model, SubObj, parent, context[key]);
      } else {
        context[key] = new SubObj(parent, key, value, model);
      }
    } else if (model.options.deep && value != null && Array.isArray(value) && !value.some(function (str) {
      return ["string", "number"].includes(_typeof(str));
    })) {
      var out = [];
      value.forEach(function (item, order) {
        var _context$key;
        var old = (_context$key = context[key]) === null || _context$key === void 0 ? void 0 : _context$key.find(function (i) {
          return i.id === (item === null || item === void 0 ? void 0 : item.id);
        });
        if (old && old.id && _typeof(old) === "object") {
          setValues(item, model, SubObj, parent, old);
          out.push(old);
        } else {
          out.push(new SubObj(parent, key, item, model));
        }
      });
      context[key] = out;
    } else {
      context[key] = value;
    }
  });
}
var _setHidden = /*#__PURE__*/new WeakMap();
var _id = /*#__PURE__*/new WeakMap();
var _error = /*#__PURE__*/new WeakMap();
var _model = /*#__PURE__*/new WeakMap();
var BasicObj = exports.BasicObj = /*#__PURE__*/function () {
  function BasicObj(values, model) {
    var _this = this;
    _classCallCheck(this, BasicObj);
    _classPrivateFieldInitSpec(this, _setHidden, {});
    _classPrivateFieldInitSpec(this, _id, null);
    _classPrivateFieldInitSpec(this, _error, {});
    _classPrivateFieldInitSpec(this, _model, void 0);
    _defineProperty(this, "isDataflux", function () {
      return true;
    });
    _defineProperty(this, "isMock", function () {
      return false;
    });
    _defineProperty(this, "setId", function (id) {
      _this.id = id;
    });
    _defineProperty(this, "getId", function () {
      if (!_classPrivateFieldGet(_id, _this)) {
        if (_this.id != null && (typeof _this.id === "string" || typeof _this.id === "number")) {
          _classPrivateFieldSet(_id, _this, _this.id.toString());
          delete _this.setId;
        } else {
          _classPrivateFieldSet(_id, _this, (0, _uuid.v4)());
        }
      }
      return _classPrivateFieldGet(_id, _this);
    });
    _defineProperty(this, "get", function (attribute, defaultValue) {
      var _ref, _classPrivateFieldGet2;
      return (_ref = (_classPrivateFieldGet2 = _classPrivateFieldGet(_setHidden, _this)[attribute]) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : _this[attribute]) !== null && _ref !== void 0 ? _ref : defaultValue;
    });
    _defineProperty(this, "getError", function () {
      var _classPrivateFieldGet3;
      var attribute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var key = attribute ? attribute : globalError;
      return (_classPrivateFieldGet3 = _classPrivateFieldGet(_error, _this)[key]) !== null && _classPrivateFieldGet3 !== void 0 ? _classPrivateFieldGet3 : false;
    });
    _defineProperty(this, "setError", function (error) {
      var attribute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (error && attribute) {
        _classPrivateFieldGet(_error, _this)[attribute] = error;
      } else if (error && !attribute) {
        _classPrivateFieldGet(_error, _this)[globalError] = error;
      } else if (!error && attribute) {
        delete _classPrivateFieldGet(_error, _this)[attribute];
      } else {
        _classPrivateFieldSet(_error, _this, {});
      }
    });
    _defineProperty(this, "setConstant", function (attribute, value) {
      var _classPrivateFieldGet4;
      _classPrivateFieldGet(_setHidden, _this)[attribute] = (_classPrivateFieldGet4 = _classPrivateFieldGet(_setHidden, _this)[attribute]) !== null && _classPrivateFieldGet4 !== void 0 ? _classPrivateFieldGet4 : value;
    });
    _defineProperty(this, "toJSON", function () {
      var attrs = Object.keys(_this);
      var out = {};
      for (var _i = 0, _attrs = attrs; _i < _attrs.length; _i++) {
        var a = _attrs[_i];
        if (_this[a] == null) {
          out[a] = _this[a];
        } else if (_this[a] instanceof _moment["default"]) {
          out[a] = _this[a].toISOString();
        } else if (_this[a] instanceof Date) {
          out[a] = (0, _moment["default"])(_this[a]).toISOString();
        } else if (_typeof(_this[a]) === "object" && _this[a].toJSON) {
          out[a] = _this[a].toJSON();
        } else if (Array.isArray(_this[a]) && _this[a].every(function (i) {
          return _typeof(i) === "object" && i.toJSON;
        })) {
          out[a] = _this[a].map(function (i) {
            return i.toJSON();
          });
        } else if (typeof _this[a] !== "function") {
          out[a] = _this[a];
        }
      }
      return out;
    });
    _defineProperty(this, "toString", function () {
      return JSON.stringify(_this.toJSON());
    });
    _defineProperty(this, "update", function () {
      return Promise.resolve();
    });
    _classPrivateFieldSet(_model, this, model);
  }
  return _createClass(BasicObj, [{
    key: "set",
    value: function set(attribute, value, hidden) {
      if (hidden) {
        _classPrivateFieldGet(_setHidden, this)[attribute] = value;
      } else {
        if (attribute === "id") {
          throw new Error("You cannot change the ID");
        }
        this[attribute] = value;
        _classPrivateFieldGet(_model, this).validateObjectAttribute(this, attribute);
      }
      return this.update();
    }
  }]);
}();